<template>
  <div class="item">
    <div class="top_title van-hairline--bottom" :class="{ no_union_id: orderItem.union_id != '1016039299' }">
      <div class="left_side">
        <h2 v-if="orderItem.union_id == '1016039299'" @click="toNext(`/ylsq/editGroup/${orderItem.unionRef}?isCheck=1`)">{{ orderItem.jieLongActName }}</h2>
        <div class="order_text">
          <p>订单号: {{ orderItem.escOrderId }}</p>
          <span class="copy_icon" @click="copyText(orderItem.escOrderId)">复制</span>
        </div>
      </div>
      <div class="right_tip" :class="{ done: orderItem.orderStatus == 7 }">{{ orderStatusObj[orderItem.orderStatus] }}</div>
    </div>
    <div class="item_box" @click="toDetails(orderItem.escOrderId, orderItem.buyerName, orderItem.buyerOnlyid)">
      <div class="item_good single" v-if="orderItem.delevery[0].prd.length == 1">
        <div class="left_img">
          <img width="70px" height="70px" :src="orderItem.delevery[0].prd[0].productPic.split('|*|')[0].replace('http:', 'https:')" />
        </div>
        <div class="right_side">
          <div class="top">
            <h2>{{ orderItem.delevery[0].prd[0].productName }}</h2>
            <p class="price">¥{{ orderItem.delevery[0].prd[0].salPrice }}</p>
          </div>
          <div class="bottom">{{ orderItem.delevery[0].prd[0].attributes }}</div>
        </div>
      </div>
      <div class="item_good more" v-if="orderItem.delevery[0].prd.length > 1">
        <div class="top_more_out">
          <div class="top_more_item">
            <div class="more_item" v-for="(item, index) in orderItem.delevery[0].prd" :key="index">
              <div class="more_img">
                <img width="70px" height="70px" :src="item.productPic.split('|*|')[0].replace('http:', 'https:')" />
              </div>
              <p class="name">{{ item.productName }}</p>
              <p class="number">共{{ item.productNum }}件</p>
            </div>
          </div>
        </div>
      </div>
      <div class="total_bottom">
        <div class="date">{{ orderItem.buyerPayTime }}</div>
        <div class="all_price">
          共{{ orderItem.itemNum }}件<span>实收¥{{ orderItem.orderAmount }}</span>
        </div>
      </div>
    </div>
    <div class="customer_box" @click="toDetails(orderItem.escOrderId, orderItem.buyerName, orderItem.buyerOnlyid)">
      <div class="title">顾客自提</div>
      <div class="text_box">
        <i class="left_icon user"></i>
        <div class="text">
          <div class="name">
            <p>联系人：{{ orderItem.buyerName }} ({{ orderItem.transUsrPhone }})</p>
            <i class="phone" @click="toPhone(orderItem.transUsrPhone)"></i>
          </div>
          <div class="address">
            <p>
              {{ orderItem.buyerNote }}
              <!-- <span class="copy_icon">复制</span> -->
            </p>
          </div>
        </div>
      </div>
      <div class="text_box">
        <i class="left_icon site"></i>
        <div class="text">
          <div class="name">
            <p>自提点：{{ orderItem.transName2 }}</p>
          </div>
          <div class="address">
            <p>{{ orderItem.transAddress }}</p>
          </div>
        </div>
      </div>
      <div class="text_box" v-if="logisticsList[orderItem.escOrderId]">
        <i class="left_icon logistics"></i>
        <div class="text">
          <div class="name">
            <p>最新物流</p>
          </div>
          <div class="address">
            <p>{{ logisticsList[orderItem.escOrderId].content }}</p>
          </div>
          <div class="time">
            <p>{{ logisticsList[orderItem.escOrderId].dealTime }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="button_box">
      <div class="button" v-if="orderItem.orderStatus === '5'" @click="toPhone(orderItem.transUsrPhone)">电话通知</div>
      <div class="button" v-if="orderItem.orderStatus === '5'" @click="sendMsg(orderItem.escOrderId, orderItem)">短信通知收货</div>
      <!-- <div class="button red">代用户签收</div> -->
    </div>

    <!-- <van-panel :title="'收货人: ' + orderItem.buyerName" :status="orderStatusObj[orderItem.orderStatus]" class="pickup-list-order">
      <div v-for="(obj, index) in orderItem.delevery[0].prd" :key="index">
        <van-card :num="obj.productNum" :price="obj.salPrice" :desc="obj.attributes" :title="obj.productName" :thumb="obj.productPic.split('|*|')[0].replace('http:', 'https:')" @click.native="toDetails(orderItem.escOrderId, orderItem.buyerName, orderItem.buyerOnlyid)" />
      </div>
      <div class="count-pay">
        共{{ orderItem.itemNum }}件 实付金额： {{ orderItem.orderAmount }}
        <span>（含运费{{ orderItem.transAmount | currency }}）</span>
      </div>
      <div slot="default">
        <span class="order-time" v-if="orderItem.orderStatus === '4' || orderItem.orderStatus === '5' || orderItem.orderStatus === '6' || orderItem.orderStatus === '7'">付款时间：{{ orderItem.buyerPayTime }}</span>
        <span class="order-time c_f44" v-if="orderItem.orderStatus === '7'">核销时间：{{ JSON.parse(orderItem.delevery[0].jsonResultStr).complete_time }}</span>
        <span class="order-time" v-if="orderItem.orderStatus === '3' || orderItem.orderStatus === '9' || orderItem.orderStatus === '1'">下单时间：{{ orderItem.createTime }}</span>
        <div class="bottom-lay">
          <van-button v-if="orderItem.orderStatus === '5'" size="small" class="send-btn" color="linear-gradient(to right, #ff8b33, #ff1b2d)" @click="toPhone(orderItem.transUsrPhone)">
            <span>电话通知</span>
          </van-button>
          <van-button v-if="orderItem.orderStatus === '5'" size="small" class="send-btn" color="linear-gradient(to right, #ff8b33, #ff1b2d)" @click="sendMsg(orderItem.escOrderId, orderItem)">
            <van-icon name="comment" class="left-ico" />
            <span>短信通知取货</span>
          </van-button>
        </div>
      </div>
    </van-panel> -->
    <!-- 设置短信通知时间 -->
    <van-popup v-model="isShowBatch" class="pop-inner large" @close="resetTimeAlert">
      <div class="pop-inner-list">
        <h3>请设置提货时间</h3>
        <div class="selected-lay">
          <div class="selected_time">
            <div class="time_day" style="margin-right:20px">
              <van-field
                v-model="getGoodsDay"
                :border="false"
                readonly
                clickable
                is-link
                arrow-direction="down"
                center
                style="padding:0 10px;width:80px;"
                @click="showGetGoodsAction=true"
                input-align="center"
              />
            </div>
            <div class="time_day">
              <van-stepper v-model="getGoodsTime" :show-plus="false" :show-minus="false" integer :max="23" :min="0" input-width="50" allow-empty @change="chnageBtn" />
            </div>
            <p class="tips_text">点前提货</p>
          </div>
          <van-button size="small" class="send-btn1" color="linear-gradient(to right, #ff8b33, #ff1b2d)" @click="batchMessage" :disabled="!hasTime">
            <span>立即通知</span>
          </van-button>
        </div>
      </div>
    </van-popup>
    <van-action-sheet v-model:show="showGetGoodsAction" :actions="actions" @select="chnageGetGoodsDay" cancel-text="取消" />
  </div>
</template>

<script>
import { sendMsgRemind } from "@/libs/api";
export default {
  name: "orderItem",
  props: ["orderItem", "logisticsList"],
  data() {
    return {
      orderStatusObj: {
        "3": "待付款",
        "4": "待配货",
        "5": "已发货",
        "6": "配货完成",
        "7": "已核销",
        "8": "拒收签收",
        "9": "已取消",
        "1": "已取消",
      },
      getGoodsDay:'今日',
      getGoodsTime:'',
      showGetGoodsAction:false,
      actions:[
        {name:'今日',color:'#ef3b39'},
        {name:'明日',color:'#333333'},
      ],
      sendMsgOrderId:'',
      isShowBatch:false,
      hasTime:false,
    };
  },
  // watch: {
  // logisticsList: function(newVal) {
  // console.log("newVal", newVal);
  // this.logistics = newVal;
  // },
  // },
  methods: {
    resetTimeAlert(){
      this.getGoodsTime='';
      this.sendMsgOrderId='';
      this.isShowBatch=false;
      this.hasTime=false;
    },
    //设置提货时间后修改按钮状态
    chnageBtn(){
      this.hasTime=this.getGoodsTime;
    },
    //切换提货时间
    chnageGetGoodsDay(e){
      this.getGoodsDay = e.name;
      this.actions.forEach((item)=>{
        item.color='#333333';
      })
      e.color='#ef3b39';
      this.showGetGoodsAction=false;
    },
    // 进入详情
    toDetails(escOrderId, buyerName, buyerOnlyid) {
      if (escOrderId) {
        this.$router.push({
          path: `/pickup/pickupDetail`,
          query: {
            escOrderId: escOrderId,
            buyerName: buyerName,
            buyerOnlyid: buyerOnlyid,
          },
        });
      } else {
        this.$toast("系统异常，请稍后再试！");
      }
    },
    // 电话通知
    toPhone(phone) {
      console.log("phone===", phone);
      // Android
      if (navigator.userAgent.indexOf("Android") > -1) {
        window.location.href = `tel:${phone}`;
      }
      // IOS
      else {
        let dataString = {
          urlScheme: `tel:${phone}`,
        };
        window.dsBridge.call("generalAction", {
          type: "8",
          ios_action: JSON.stringify(dataString),
        });
      }
    },
    batchMessage(){
      let that=this;
      this.$dialog
        .confirm({
          title: "发送短消息",
          message: "确认发送短消息",
          confirmButtonText: "确认发送",
          cancelButtonText: "取消",
        })
        .then(() => {
          let data={
            day:this.getGoodsDay=='今日'?'0':'1',
            sendTime:this.getGoodsTime,
            queryType: 0, 
            escOrderid: that.sendMsgOrderId
          }
          sendMsgRemind(data, "jsoncallback").then((res) => {
            if (res.returnCode === "0000") {
              this.$toast("短信发送成功");
              this.resetTimeAlert();
            } else {
              this.$toast(res.returnMessage);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 发短息
    sendMsg(orderId) {
      this.isShowBatch=true;
      this.sendMsgOrderId=orderId;
      // this.$dialog
      //   .confirm({
      //     title: "发送短消息",
      //     message: "确认发送短消息",
      //     confirmButtonText: "确认发送",
      //     cancelButtonText: "取消",
      //   })
      //   .then(() => {
      //     sendMsgRemind({ queryType: 0, escOrderid: orderId }, "jsoncallback").then((res) => {
      //       if (res.returnCode === "0000") {
      //         this.$toast("短信发送成功");
      //       } else {
      //         this.$toast(res.returnMessage);
      //       }
      //     });
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
    },
  },
};
</script>

<style scoped lang="scss">
.order-list {
  background: #f5f5f5;
}
.pickup-list-order {
  margin-top: 10px;
  .count-pay {
    padding: 5px 10px;
    text-align: right;
    font-size: 14px;
    color: #333;
    span {
      font-size: 13px;
      color: #999;
    }
  }
  .order-time {
    font-size: 13px;
    color: #999;
    width: 100%;
    line-height: 22px;
    padding: 0 10px;
    display: block;
    box-sizing: border-box;
    &.c_f44 {
      color: #f44;
    }
  }
  .bottom-lay {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 5px 10px;
    box-sizing: border-box;
  }
  .van-card__title {
    font-size: 14px;
    line-height: 18px;
    height: 36px;
    overflow: hidden;
    color: #333;
  }
  .van-card__thumb {
    width: 96px;
    height: 96px;
  }
  .van-card__bottom,
  .van-card__desc {
    line-height: 15px;
  }
  .van-card__desc {
    font-size: 12px;
    color: #999;
    padding: 10px 0 16px 0;
  }
  .van-card__price {
    font-size: 15px;
    color: #333;
  }
  .van-card__num {
    color: #999;
  }
  .van-cell {
    padding: 10px;
  }
  .van-card {
    padding: 10px;
  }
  .send-btn {
    height: 25px;
    border-radius: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    margin: 0 5px;
    .left-ico {
      margin-right: 10px;
    }
    .van-button__text {
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
    }
  }
}
.item {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
  .copy_icon {
    width: 32px;
    height: 15px;
    border-radius: 2px;
    border: 1px solid #999999;
    color: #333;
    font-size: 11px;
    text-align: center;
    line-height: 16px;
    display: inline-block;
    margin-left: 6px;
  }
  .top_title {
    height: 64px;
    padding: 6px 0 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    &.no_union_id {
      height: 46px;
    }
    .left_side {
      overflow: hidden;
      flex: 1;
      h2 {
        color: #333;
        font-weight: bold;
        font-size: 14px;
        width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 4px;
      }
      .order_text {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        p {
          font-size: 12px;
          color: #999;
        }
      }
    }
    .right_tip {
      width: 64px;
      height: 27px;
      background: #fef0e5;
      border-radius: 14px 0px 0px 14px;
      line-height: 27px;
      text-align: center;
      color: #fe7003;
      font-size: 12px;
      &.done {
        background: #f6f6f7;
        color: #999;
      }
    }
  }
  .item_box {
    padding: 12px;
    .item_good {
      &.single {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .left_img {
          width: 70px;
          height: 70px;
          margin-right: 8px;
          img {
            width: 70px;
            height: 70px;
            border-radius: 4px;
          }
        }
        .right_side {
          flex: 1;
          .top {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            h2 {
              font-weight: 400;
              color: #333;
              font-size: 13px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              width: 80%;
            }
            .price {
              font-weight: bold;
              color: #333;
              font-size: 12px;
            }
          }
          .bottom {
            color: #999;
            font-size: 12px;
            margin-top: 4px;
          }
        }
      }
      &.more {
        position: relative;
        .top_more_out {
          overflow-x: scroll;
          scrollbar-width: none;
          white-space: nowrap;
          &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
          }
          .top_more_item {
            min-width: 100%;
            height: 116px;
            display: inline-flex;
            .more_item {
              width: 70px;
              margin-right: 8px;
              &:after {
                content: "";
                width: 18px;
                height: 100%;
                background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0.1) 100%);
                right: 0;
                top: 0;
                position: absolute;
              }
              &:last-child {
                margin-right: 0;
              }
              .more_img {
                width: 70px;
                height: 70px;
                img {
                  width: 70px;
                  height: 70px;
                  display: block;
                  border-radius: 4px;
                }
              }
              .name {
                font-size: 12px;
                color: #333;
                width: 70px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 4px 0;
              }
              .number {
                color: #666;
                font-size: 12px;
                text-align: center;
              }
            }
          }
        }
      }
    }
    .total_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
      .date {
        color: #999;
        font-size: 12px;
      }
      .all_price {
        color: #999;
        font-size: 13px;
        span {
          font-weight: bold;
          font-size: 14px;
          color: #333;
          margin-left: 6px;
        }
      }
    }
  }
  .customer_box {
    background: #f9f9f8;
    border-radius: 4px;
    margin: 0 10px 12px 10px;
    padding: 10px 16px 10px 10px;
    box-sizing: border-box;
    .title {
      font-weight: bold;
      color: #333;
      font-size: 13px;
    }
    .text_box {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 10px;
      .left_icon {
        width: 16px;
        height: 16px;
        &.user {
          background: url("../../assets/img/icon_6.png") no-repeat;
          background-size: 100% 100%;
        }
        &.site {
          background: url("../../assets/img/icon_3.png") no-repeat;
          background-size: 100% 100%;
        }
        &.logistics {
          background: url("../../assets/img/icon_4.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text {
        margin-left: 10px;
        flex: 1;
        .name {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            color: #333;
            font-size: 13px;
            margin-right: 6px;
            margin-bottom: 2px;
          }
          .phone {
            width: 16px;
            height: 16px;
            background: url("../../assets/img/icon_5.png") no-repeat;
            background-size: 100% 100%;
            margin-left: 2px;
          }
        }
        .address {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            font-size: 13px;
            color: #999;
            margin-right: 6px;
            line-height: 22px;
          }
        }
        .time {
          color: #666;
          font-size: 12px;
        }
      }
    }
  }
  .button_box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 12px 12px 0;
    .button {
      height: 24px;
      padding: 0 12px;
      line-height: 24px;
      box-sizing: border-box;
      color: #333;
      font-size: 12px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #c8c8c8;
      margin-left: 8px;
      &.button.red {
        border: 1px solid #ff3d3d;
        color: #ff3d3d;
      }
    }
  }
}
.pop-inner {
  border-radius: 10px;
  width: 65%;
  &.large {
    width: 80%;
    .pop-inner-list {
      padding: 20px;
      max-height: 300px;
    }
  }
  &-list {
    padding: 20px 30px;
    max-height: 300px;
    h3 {
      color: #333;
      text-align: center;
      margin-bottom: 10px;
    }
    ul {
      li {
        font-size: 12px;
        color: #666;
        &.cur {
          color: red;
        }
      }
      li + li {
        margin-top: 10px;
      }
    }
    .radio-lay {
      margin-top: 20px;
    }
    .selected-lay {
      margin-top: 10px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
    }
  }
}
.selected_label{
  padding:0 16px;
  color: #323233;
  font-size: 14px;
  margin-bottom: 10px;
}
.selected_time{
  display: flex;
  margin-left: 16px;
  color: #323233;
  font-size: 14px;
  .time_day{
    border:1px solid #ddd;
    margin-right: 5px;
    border-radius: 5px;
    display: flex;
    align-items: center;
  }
  .tips_text{
    line-height: 29px;
  }
  ::v-deep .van-stepper__input{
    background-color: #fff;
  }
}
.send-btn1 {
  height: 25px;
  border-radius: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  display:block;
  margin: 20px auto 0;
  .left-ico {
    margin-right: 10px;
  }
  .van-button__text {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
</style>
